import {Component, EventEmitter, Output} from '@angular/core';
import {AppService} from '../../app.service';
import {Router} from '@angular/router';
import {SistemaService} from '../../Servicios/Sistema.Service';
import {OpcionMenu} from '../../Modelo/OpcionMenu.model';
import {FuncionesUsuarioEnum, TipoIconoEnum, TipoOpcionMenuEnum} from '../../Enumeraciones/Enumeraciones.enum';
import {TranslateService} from '@ngx-translate/core';
import {UsuarioService} from '../../Servicios/Usuario.service';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {environment} from '../../../environments/environment';

@Component(
  {
    selector: 'menuOpciones',
    templateUrl: './Menu.template.html',
    styleUrls: ['./Menu.scss'],
    animations: [
      trigger("expandCollapseDetails", [
        state(
          "oculto",
          style({
            height: "0px",
            padding: "0px"
          })
        ),
        state(
          "visible",
          style({
            height: "*",
            padding: "8px 0px"
          })
        ),
        transition('oculto => visible', animate('0.2s linear')),
        transition('visible => oculto', animate('0.2s linear'))
      ])
    ]
  })

export class MenuComponent
{
  @Output() MenuEstatico : EventEmitter<any> = new EventEmitter<any>();
  @Output() MenuAbierto : EventEmitter<any> = new EventEmitter<any>();

  public abierto : boolean;
  public estatico : boolean;
  public TipoIconoEnum = TipoIconoEnum;
  public TipoOpcionMenuEnum = TipoOpcionMenuEnum;
  public nombreUsuario : string;

  public sidebarCompleto : boolean;
  
  logo: string;
  logoSmall:string;

  constructor(private appService:AppService, private router: Router, public sistemaService : SistemaService, private translate : TranslateService, public usuarioService : UsuarioService)
  {
    this.abierto = false;
    this.estatico = localStorage.getItem(this.sistemaService.localStoreVariable.SideBarFijo) == '1';
    this.nombreUsuario = this.sistemaService.usuario.nombre;

    this.sidebarCompleto = this.estatico;
    
      this.logo = environment.logo + "logo.png";
      this.logoSmall = environment.logo + "logoSmall.png";
  }

  ngOnInit()
  {
    this.MenuEstatico.emit(this.estatico);
    this.MenuAbierto.emit(this.abierto);
  }

  OpcionSeleccionada(opcion : OpcionMenu, modulo : OpcionMenu)
  {
    if(opcion.TipoModulo == TipoOpcionMenuEnum.Modulo || opcion.TipoModulo == TipoOpcionMenuEnum.SubModulo)
    {
      opcion.Abierto = !opcion.Abierto;
    }
    else if (opcion.TipoModulo == TipoOpcionMenuEnum.Pantalla)
    {
      this.router.navigateByUrl(opcion.Ruta);

      this.CambiarAbiertoModulo(modulo, false);
    }
    else if (opcion.TipoModulo == TipoOpcionMenuEnum.Funcion)
    {
      this.CambiarAbiertoModulo(modulo, false);

      switch (opcion.Funcion)
      {
        case FuncionesUsuarioEnum.CambiarPassword:
          this.CambiarPassword();
          break;

        case FuncionesUsuarioEnum.CerrarSesion:
          this.CerrarSesion();
          break;

        case FuncionesUsuarioEnum.CerrarSesionEnmascarado:
          this.CerrarSesionEnmascarado();
          break;

        default:
          break;

      }
    }
  }

  IrPantalla(pantalla : OpcionMenu)
  {
    this.router.navigateByUrl(pantalla.Ruta);

    this.CambiarAbiertoModulo(pantalla, false);
  }

  CambiarEstaticoSideBar()
  {
    this.estatico = !this.estatico;
    this.CerrarOpcionesMenu();

    localStorage.setItem(this.sistemaService.localStoreVariable.SideBarFijo, this.estatico ? "1" : "0");
    this.MenuEstatico.emit(this.estatico);

    this.SetVerLogoCompleto();
  }

  CambiarAbiertoSideBar(valor : boolean)
  {
    this.abierto = valor;
    this.CerrarOpcionesMenu();

    this.MenuAbierto.emit(this.abierto);

    this.SetVerLogoCompleto();
  }

  CambiarAbiertoModulo(modulo : any, abierto : boolean)
  {
    if (!this.estatico)
    {
      modulo.Abierto = abierto;
    }
  }

  SetVerLogoCompleto()
  {
    if (this.abierto || this.estatico)
    {
      this.sidebarCompleto = true;
    }
    else
    {
      setTimeout(() =>
      {
        this.sidebarCompleto = false;
      }, 290);
    }
  }

  CerrarOpcionesMenu()
  {
    if(!this.abierto && !this.estatico)
    {
      this.sistemaService.opcionesMenu.map(p =>
      {
        p.Abierto = false;
      });
    }
  }

  CerrarSesion()
  {
    this.usuarioService.CerrarSesion();
  }

  CerrarSesionEnmascarado()
  {
    this.usuarioService.CerrarSesionEnmascarado();
  }

  CambiarPassword()
  {
    this.router.navigateByUrl('/app/cambiarPassword');
  }

  GetEstatusSubMenu(abierto : boolean)
  {
    return abierto ? "visible" : "oculto";
  }
}
